import React from "react";
import {connect} from "react-redux";
import SVG from "react-inlinesvg";
import closeicon from "../../../assets/close.svg";
import UserModal from './UserModal'
import "../../User/user.css"

class AdminModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            roles: {},
            userRole: ''
        };
    }

    render(){
        return (
            <React.Fragment><UserModal data={this.props.data} roles={this.props.roles} toggleModal={this.props.toggleModal}/></React.Fragment>
        )
    }
}
export default connect(null)(AdminModal);